import BaseService from "../../services/base_service"

import ApiMsApproveRequestMaterialsService from '@/services/ms_approve_request_materials'
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";

const deliveryRequestsService = new BaseService(
  process.env.VUE_APP_MS_DELIVERY_REQUESTS_URL,
  process.env.VUE_APP_MS_DELIVERY_REQUESTS_API_KEY
)

const materialsService = new BaseService(
  process.env.VUE_APP_MS_REQUESTS_MATERIALS_URL,
  process.env.VUE_APP_MS_REQUESTS_MATERIALS_API_KEY
)

export const state = {
    requestServicesQuotes: {
        total_items: 0,
        total_pages: 1,
        items: []
    },
    allSupliers: {
        total: 0,
        number_of_pages: 1,
        items: []
    }
}

export const getters = {
    requestServicesQuotes: (state) => state.requestServicesQuotes,
    allSupliers: (state) => state.allSupliers,
} 

export const mutations = {
    SET_REQUEST_SERVICES_QUOTES(state, payload) {
      state.requestServicesQuotes = payload  
      state.requestServicesQuotes.items = payload.items.map(item => {
            return {
              ...item,
              assigned_user: item.assigned_users && item.assigned_users.length ? item.assigned_users[0].user.id : null,
            }
        })
        state.requestServicesQuotes.items.forEach(item => {
            item.items.forEach(service => {
                if(service.quotations.length){
                    service.quotation_attached = {
                        id: service.quotations[0].quotation.id,
                        shopping_index: service.quotations[0].quotation.shopping_index,
                    }
                    service.documents = [
                      ...service.documents,
                      ...service.quotations.map(itemDocument => {
                        return {
                          ...itemDocument.quotation_document,
                          quotation_id: itemDocument.quotation.id,
                          selected: itemDocument.selected,
                          unique_supplier: itemDocument.unique_supplier,
                          unique_supplier_with_contract: (itemDocument.unique_supplier_with_contract !== undefined ? itemDocument.unique_supplier_with_contract : itemDocument.has_contract) || false,
                          has_contract: (itemDocument.has_contract !== undefined ? itemDocument.has_contract : itemDocument.unique_supplier_with_contract) || false,
                          tax_exempt: itemDocument.quotation_document.tax_exempt
                        }
                      })
                    ]

                    service.documents.forEach(doc => {
                      doc.unique_supplier_with_contract = doc.unique_supplier_with_contract || doc.has_contract || false;
                      doc.has_contract = doc.has_contract || doc.unique_supplier_with_contract || false;
                    });
                }
            })
        });
    },
    UPDATE_STATUS_SERVICES_REQUEST(state, payload){
        let requestIndex = state.requestServicesQuotes.items.findIndex(item => item.id === payload.request_id)
        state.requestServicesQuotes.items[requestIndex].items.forEach(service => {
          if(service.status === REQUEST_SERVICE_CONSTANTS.service_statuses.in_quotation){
            service.status = REQUEST_SERVICE_CONSTANTS.service_statuses.in_review
          }
        });
    },
    SPLICE_FILE_SERVICE_DELETED(state, payload){
        let requestIndex = state.requestServicesQuotes.items.findIndex(item => item.id === payload.request_id)
        let serviceIndex = state.requestServicesQuotes.items[requestIndex].items.findIndex(item => item.id === payload.service_id)
        state.requestServicesQuotes.items[requestIndex].items[serviceIndex].documents = state.requestServicesQuotes.items[requestIndex].items[serviceIndex].documents.filter(item => {
            return item.id !== payload.document_id
        }) 
    },    
    UPDATE_FILE_SUPPLIER_LETTER(state, payload){
      let requestIndex = state.requestServicesQuotes.items.findIndex(item => item.id === payload.request_id)
      let serviceIndex = state.requestServicesQuotes.items[requestIndex].items.findIndex(item => item.id === payload.service_id)
      state.requestServicesQuotes.items[requestIndex].items[serviceIndex].documents.forEach(item => {
        if(item.id == payload.document_id){
          item.unique_supplier = payload.unique_supplier
        }
      }) 
    },    
    SPLICE_COMMENT_REQUEST_DELETED(state, payload){
      let requestIndex = state.requestServicesQuotes.items.findIndex(item => item.id === payload.request_id)
      state.requestServicesQuotes.items[requestIndex].comments = state.requestServicesQuotes.items[requestIndex].comments.filter(item => {
          return item.id !== payload.comment_id
      })
    },
    SPLICE_COMMENT_SERVICE_DELETED(state, payload){
      let requestIndex = state.requestServicesQuotes.items.findIndex(item => item.id === payload.request_id)
      let serviceIndex = state.requestServicesQuotes.items[requestIndex].items.findIndex(item => item.id === payload.service_id)
      state.requestServicesQuotes.items[requestIndex].items[serviceIndex].comments = state.requestServicesQuotes.items[requestIndex].items[serviceIndex].comments.filter(item => {
          return item.id !== payload.comment_id
      }) 
    },
    SET_SUPPLIERS(state, payload){
      state.allSupliers = payload
    },
    UPDATE_SERVICE_EXCHANGE_RATE(state, payload){
      let request = state.requestServicesQuotes.items[payload.requestServiceIndex]
      let service = request.items.findIndex(
        (item) => item.id === payload.serviceUpdated.id
      )
      request.items[service].documents = payload.exchangeRate
    },
}


export const actions = {
  async getDataOcFromSoc({ commit }, payload = {}) {
    try {
      const resp = (await materialsService.get(
        `/api/requests/purchase_order_pdf_info`,
        payload
      )).data;
      return resp;
    } catch (error) {
      return error;
    }
  },
  async getUserIsSupplyingUser({ commit }, payload = {}) {
      try {
          const resp = (await ApiMsApproveRequestMaterialsService.put(
              `/api/service_request/is_abastecimiento?user=${payload.user}`, payload)).data
          return resp
      } catch (error) {
          return error
      }
  },
  async getRequestServicesQuotes({ commit }, payload = {}) {
      try {
          const resp = (await ApiMsApproveRequestMaterialsService.get(
              `/api/service_request`, payload)).data
          commit('SET_REQUEST_SERVICES_QUOTES', resp)
          return resp
      } catch (error) {
          return error
      }
  },
  async createCommentService({commit}, payload){
    let queryParams = new URLSearchParams({
      comment: payload.comment,
      item_id: payload.service_id,
      user: payload.user
    })
      try {
        const resp = await ApiMsApproveRequestMaterialsService.post(
          `/api/service_request/comment_item?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async createCommentRequest({commit}, payload){
      let queryParams = new URLSearchParams({
        comment: payload.comment,
        request_id: payload.request_id,
        user: payload.user
      })
        try {
          const resp = await ApiMsApproveRequestMaterialsService.post(
            `/api/service_request/comment_request?${queryParams}`, payload)
            return resp
          } catch (error) {
            return error.response
          }
      },
    async deleteCommentService({commit}, payload){
      try {
        const resp = await ApiMsApproveRequestMaterialsService.delete(
          `/api/service_request/delete_item_comment?comment_id=${payload.comment_id}&user=${payload.user}`, payload)
          commit('SPLICE_COMMENT_SERVICE_DELETED', payload)
          return resp
        } catch (error) {
          console.log(error)
          return error.response
        }
    },
    async deleteCommentRequest({commit}, payload){
      try {
        const resp = await ApiMsApproveRequestMaterialsService.delete(
          `/api/service_request/delete_comment?comment_id=${payload.comment_id}&user=${payload.user}`, payload)
          commit('SPLICE_COMMENT_REQUEST_DELETED', payload)
          return resp
        } catch (error) {
          console.log(error)
          return error.response
        }
    },
    async updateService({commit}, payload){
      try {        
   
        let payloadUpdateFiles = new FormData()
        payloadUpdateFiles.append('body', JSON.stringify({
          item_id: payload.service_id,
          user: payload.user,
          quantity: payload.quantity,
          documents: payload.documents,
          quotations: payload.quotations,
        }))
        if(payload.files){
          for(let i = 0; i < payload.files.length; i++){
            payloadUpdateFiles.append(`files`, payload.files[i])
          }
        }
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `api/service_request/update_item`,
          payloadUpdateFiles
        )
        return resp
      } catch (error) {
        return error.response
      }
    },
    async updateStatusService({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/approve_item?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error?.response || error
        }
    },
    async updateStatusServiceToApproveFromPurchase({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/abastecimiento_approve_service_request_item?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error?.response || error
        }
    },
    async updateStatusRequestToApproveFromPurchase({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/abastecimiento_approve_service_request?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error?.response || error
        }
    },
    
    async updateStatusRequestToPendingApproval({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/approve_request?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequesToRejection({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/reject_request?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestMaverickToPendingApproval({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/approve_maverick_service_request?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestMaverickToReviewUser({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/send_to_user_revision_maverick?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestToReviewUser({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/send_to_user_revision_v2?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestMaverickToRejection({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/reject_maverick_service_request?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestMaverickToReviewPurchase({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/maverick_user_approve?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestToReviewPurchase({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/ready_for_approval?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    // Este método se creó para actualizar
    //  el tipo de solicitud en caso 
    // de que el usuario quiera cambiar a SOC a MEVERICK
    async updateRequestType({ commit }, payload) {
      const requestType = payload.request_type_name || payload.request_type;

      const queryParams = new URLSearchParams({
        request_id: payload.request_id,
        request_type: requestType,
        user: payload.user,
      });

      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/update_request_type?${queryParams}`,
          {...payload, request_type: requestType},
        );
        return resp;
      } catch (error) {
        const status = error?.response?.status;
        if (status === 404 || status === 405) {
          try {
            const fallbackResp = await ApiMsApproveRequestMaterialsService.put(
              `/api/service_request/update_request_type`,
              {...payload, request_type: requestType},
            );
            return fallbackResp;
          } catch (fallbackError) {
            return fallbackError.response || fallbackError;
          }
        }
        return error.response || error;
      }
    },
    //  fin de 
    async updateStatusServiceToQuotation({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/return_item_to_quotation?${queryParams}`, payload)
          return resp
        } catch (error) {
          return error.response
        }
    },
    async updateStatusRequestToQuotation({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/return_to_quotation?${queryParams}`, payload)
        return resp
      } catch (error) {
        return error.response
      }
    },
    async updateStatusRequestToReview({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/check_request?${queryParams}`, payload)
        commit('UPDATE_STATUS_SERVICES_REQUEST', payload)
        return resp
      } catch (error) {
        return error.response
      }
    },
    
    async deleteService({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.delete(
          `/api/service_request/delete_item?${queryParams}`, payload)
        return resp
      } catch (error) {
        return error.response
      }
    },
    async changeSingleSupplierLetterFile({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.put(
          `/api/service_request/mark_unique_supplier?${queryParams}`, payload)
        return resp
      } catch (error) {
        console.log(error)
        return error.response
      }
    },
    async deleteFileService({ commit }, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = await ApiMsApproveRequestMaterialsService.delete(
          `/api/service_request/delete_document?${queryParams}`, payload)
        commit('SPLICE_FILE_SERVICE_DELETED', payload)
        return resp
      } catch (error) {
        return error.response
      }
    },
    async getSuppliers({ commit }, payload) {
      try {
        const resp = (await deliveryRequestsService.get(
          `/api/supplier_creation/sap_suppliers`, payload)).data
        commit('SET_SUPPLIERS', {
          ...resp,
          items: resp.items.map(item => {
            return {
              ...item,
              origin: "SAP"
            }
          })
        })
        return resp
      } catch (error) {
        return error
      } 
    },
    async getServicesDeleted(_, payload) {
      let queryParams = new URLSearchParams({...payload})
      try {
        const resp = (await ApiMsApproveRequestMaterialsService.get(
          `/api/service_request/get_deleted_items?${queryParams}`, {})).data
        return resp
      } catch (error) {
        return []
      } 
    },
    async getExchangeRate(_, payload = {}) {
      try {
        let queryParams = new URLSearchParams({...payload})
        const resp = (await ApiMsApproveRequestMaterialsService.get(
          `/api/get_exchange_rate?${queryParams}`, {})).data
        return resp
      } catch (error) {
        return error
      }
    },
    clearAllSuppliers({ commit }) {
      commit('SET_SUPPLIERS', {
        total: 0,
        number_of_pages: 1,
        items: []
      })
    },
    setSuppliersExternal({ commit }, payload) {
      commit('SET_SUPPLIERS', {
        ...payload,
        items: payload.items.map(item => {
        return {
          ...item,
          code: item.rut,
          name: item.official_name,
          emai: item.contact_user_email,
          origin: "Formulario proveedores"
        }
      })
      })
    },
    updateServiceExchangeRate({ commit }, payload) {
      commit('UPDATE_SERVICE_EXCHANGE_RATE', payload)
    },
    async assignUserToRequestOc({commit}, payload){
      try {
        const resp = await ApiMsApproveRequestMaterialsService.post(
          `/api/quotation/link_quotation_approver?user=${payload.user}&service_request_id=${payload.request_id}&approver_id=${payload.approver_id}`,
          payload
        )
        return resp
      } catch (error) {
        return error
      }
    },
    async unassignUserToRequestOc({commit}, payload){
      try {
        const resp = await ApiMsApproveRequestMaterialsService.post(
          `/api/quotation/unlink_quotation_approver?user=${payload.user}&service_request_id=${payload.request_id}&approver_id=${payload.approver_id}`,
          payload
        )
        return resp
      } catch (error) {
        return error
      }
    },
}